export const types = {
    REPEAT: 'REPEAT'
};